import React from 'react';
import { useLocation } from 'react-router-dom';

export default function WhatsAppHome({ children }) {
  // Na tela de Atendimento o chat ocupa a altura toda (ela já tem o próprio cabeçalho)
  const { pathname } = useLocation();
  const isChat = pathname === '/whatsapp' || pathname === '/whatsapp/';
  return (
    <div className={isChat ? 'p-2 md:p-4' : 'p-4 space-y-4'} data-testid="whatsapp-home">
      {!isChat && pathname !== '/whatsapp/contatos' && (
        <div>
          <h1 className="text-2xl font-bold">Atendimento WhatsApp</h1>
          <p className="text-sm text-muted-foreground">Gerencie conversas, contatos, respostas rápidas e automações</p>
        </div>
      )}
      {children}
    </div>
  );
}
